<template>
  <div>
    <v-card flat>
      <v-card-title>
        <v-toolbar dark color="lime">
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <v-toolbar-title
            >JND CONFERENCE 2024 ABSTRACT REVIEWERS ASSESSMENT.</v-toolbar-title
          >
        </v-toolbar>
      </v-card-title>
      <v-alert :value="error_alert_value" type="error"
        >Please fix all errors before saving. Ensure that the required input on
        the form is filled correctly</v-alert
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-progress-linear
              :indeterminate="true"
              color="lime"
              v-if="sending"
            ></v-progress-linear>
            <v-flex xs12 sm12 md12>
              <h3 class="font-weight-light">Article Name</h3>
              <div color="lime" class="font-weight-bold">
                {{ model.article_name }}
              </div>
            </v-flex>
            <v-divider></v-divider>
            <!--<v-flex xs12 sm12 md12>
              <h3 class="font-weight-light">Authors</h3>
              <div color="lime" class="font-weight-bold">
                {{ model.authors }}
              </div>
            </v-flex>-->
            <v-divider></v-divider>
            <v-flex xs12 sm12 md12>
              <h3 class="font-weight-light">Keywords</h3>
              <div color="lime" class="font-weight-bold">
                {{ model.keywords }}
              </div>
            </v-flex>
            <v-divider></v-divider>
            <v-flex xs12 sm12 md12>
              <h3 class="font-weight-light">Abstract</h3>
              <div color="lime" class="font-weight-bold">
                {{ model.abstract }}
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 class="mt-5">
              <h3 class="font-weight-light">
                Set your status for this Abstract
              </h3>
              <v-radio-group v-model="abstract_status">
                <v-radio
                  label="Approve for poster"
                  value="Approve for poster"
                  color="lime"
                ></v-radio>
                <v-radio
                  label="Approve for Oral Presentation"
                  value="Approve for oral Presentation"
                  color="lime"
                ></v-radio>
                <v-radio label="Reject" value="reject" color="lime"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea
                label="Comments"
                v-model="comment"
                :error-messages="errors.comment"
                color="lime"
                rows="10"
                outline
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm12 md12 class="mt-1">
              <v-btn color="lime darken-1" block @click.native="fab_button"
                >Save</v-btn
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :multi-line="mode"
      :right="x"
      :top="y"
      :timeout="timeout"
    >
      {{ snackbar_text }}
      <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import swal from "sweetalert2"
import {
  jndArticleAssessmentReviewOneUrl,
  jndArticleAssessmentReviewUrl
} from "@/config"
export default {
  data() {
    return {
      menu1: false,
      dialog_add: false,
      show_container_can: false,
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      timeout: 6000,
      menu: false,
      disabled: false,
      model: {
        article_name: "",
        keywords: "",
        abstract: "",
        authors: ""
      },
      downloaded: false,
      error_alert_value: false,
      errors: {},
      sending: false,
      comment: "",
      abstract_status: ""
    }
  },
  beforeMount() {
    if (this.$route.params.token != "") {
      this.fetchData()
      this.downloaded = true
    } else {
      swal({
        title: "Unauthorized",
        text: "You are not authorized to use this service",
        type: "warning",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
    }
  },
  methods: {
    fab_button() {
      var vm = this
      swal({
        title: "Confirm",
        text: "Do you want to submit the form",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#CDDC39",
        cancelButtonColor: "#F44336",
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          vm.saveEdit()
        } else if (
          // Read more about handling dismissals
          result.dismiss === "cancel"
        ) {
          swal({
            title: "Cancelled",
            text: "form was not submitted",
            type: "error",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
        }
      })
    },
    fetchData() {
      var vm = this
      vm.submit_type = false
      vm.snackbar_text = "Please stand by as background data is loading."
      vm.snackbar = true
      vm.x = "right"
      vm.y = "top"
      vm.mode = "multi-line"
      vm.timeout = 8000
      vm.loaded = true
      var data = {
        id: vm.$route.params.token
      }

      const options = {
        method: "POST",
        data: data,
        url: jndArticleAssessmentReviewOneUrl
      }
      vm.downloaded = true
      axios(options)
        .then(function(response) {
          if (response.data) {
            vm.downloaded = false
            Vue.set(vm.$data, "model", response.data)
            vm.loaded = false
            vm.submit_type = true
            vm.snackbar_text = "Background data successfully loaded."
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
            vm.timeout = 3000
          }
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    saveEdit() {
      var vm = this
      vm.sending = true
      vm.disabled = true
      vm.downloaded = true

      var data = {
        comment: vm.comment,
        abstract_status: vm.abstract_status,
        id: vm.$route.params.token
      }

      const options = {
        method: "POST",
        data: data,
        url: jndArticleAssessmentReviewUrl
      }
      vm.downloaded = true
      vm.error_alert_value = false
      axios(options)
        .then(function(response) {
          if (response.data.success) {
            swal({
              title: "Submitted",
              text: "Submission is successful",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.comment = ""
            vm.abstract_status = ""
          }
          if (response.data.empty) {
            vm.error_alert_value = true
            swal({
              title: "Validation",
              text: "Fill in all fields.",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          vm.sending = false
          vm.disabled = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error)
          if (error.response.data) {
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.error_alert_value = true
            vm.downloaded = false
          }
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/jnd-article-assessment-review.vue